import { ChangeDetectionStrategy, Component, input, signal, } from '@angular/core';
import { ImageDirective } from '../../../../../@common/DOM/image.directive';
import { SlideItem } from '../../../content/sections/slide-item/slide-item.component';

@Component({
    selector: 'app-timeline-slides',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ImageDirective],
    styles: `
        :host {
            display: block;
            position: relative;
            width: 100%;
            height: 100%;
        }

        .timeline-stamp {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 5px;
            height: 5px;
            background-color: #fff;
            z-index: 10;

            @media (hover: hover) {
                &:hover {
                    .overlay-parent {
                        .overlay-img {
                            opacity: 1;
                        }
                    }

                    transition: all 0.2s ease;
                    width: 9px;
                    height: 9px;
                }
            }
        }

        .overlay-parent {
            position: relative;

            .overlay-img {
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 175px;
                height: 175px;
                opacity: 0;
                pointer-events: none;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
        }
    `,
    template: `
        @for (slide of slides(); let i = $index; track i) {
            <div class="timeline-stamp" [style.left]="(slide.timestamp! / durationSec()) * 100 +  '%'"
                 (mouseover)="hoveredSlide.set(i)" (mouseleave)="hoveredSlide.set(null)">
                @if (hoveredSlide() === i) {
                    <div class="overlay-parent">
                        <div class="overlay-img">
                            <img [src]="slide.image" alt="slide-img" loading="eager"/>
                        </div>
                    </div>
                }
            </div>
        }
    `
})
export class VideoTimelineComponent {
    public slides = input.required<SlideItem[]>();
    public durationSec = input.required<number>();
    public hoveredSlide = signal<number | null>(null);
}
